// extracted by mini-css-extract-plugin
module.exports = {"main":"CategorySlider_main_3E29Q","heading":"CategorySlider_heading_38b_k"};